<template>
    <div class="p20 power-set" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">编辑权限</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" size="small" @click="submit" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm"
                v-model="submitForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
        <!-- 权限的设置 start -->
        <ly-power-set :list="submitForm.config"></ly-power-set>
        <!-- 权限的设置 end -->
    </div>
</template>
<script>
    import AddFormConfig from './add-form'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyRouterButton from '@c/router-button'
    import LyPowerSet from './set'
    export default {
        mixins: [
            AddFormConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyRouterButton,
            LyPowerSet
        },
        data () {
            return {
                loading: false,
                submitLoad: false, // 提交按钮的状态标识
                infoId: 0,
                submitForm: {},
                powersetList: [] // 权限设置列表 
            }
        },
        created () {
            this.init()
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'CheckinEdit') {
                    this.init()
                }
            }
        },
        methods: {
            init () {
                this.loading = true
                // 获取详情的ID
                this.infoId = this.$route.params.id
                if (this.infoId) {
                    this.queryEditData()
                } else {
                    this.$message({
                        message: '无ID',
                        type: 'warning'
                    })
                }
            },
            /**
             * 获取权限详情 
             * @return {[type]} [description]
             */
            queryEditData () {
                this.$api.queryArr(['api/quanxian', 'edit'], null, [this.infoId]).then((rs) => {
                    this.submitForm = rs
                    // 设置表单中的回填数据
                    this.$refs['searchForm'].initBindFormData(rs)
                    // 设置UUID
                    this.submitForm.uuid = this.$utils.createUUID()
                    this.loading = false
                }).catch((error) => {
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 数据的提交
             */
            submit () {
                if (this.$refs['searchForm'].validateForm()) {
                    this.submitLoad = true
                    // 获得得查询的字段
                    this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                    this.$api.save('api/quanxian/' + this.infoId, this.submitForm).then((rs) => {
                        this.submitLoad = false
                        this.$router.push('/bill/power/list')
                        // 更新UUID
                        this.submitForm.uuid = this.$utils.createUUID()
                    }).catch((error) => {
                        this.submitLoad = false
                        this.$message({
                            message: error,
                            type: 'warning'
                        })
                    })
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>
<style>
    .power-set {
        .el-collapse {
            border:1px solid #ebeef5;
        }
        .el-collapse-item{
            position: relative;
            background-color: #08a;
        }
        .el-collapse-item__header {
            padding-left:25px;
            &.is-active{
                border-bottom:1px solid #ebeef5;
            }
        }
        .el-collapse-item__arrow{
            position:absolute;
            left:10px;
        }
        .el-collapse-item__content{
            padding:10px;
            background:#fbfdff;
        }
    }
     .power-set .el-collapse-item .powerSwitch{
        position: absolute;
        top:10px;
        right: 10px;
     }
    .power-set table {
        width: 100%;
        padding-bottom: 5px;
        border-bottom: 1px dashed #dfe6ec;
    }
    .power-page-title  {
        font-size: 14px;
        font-weight: bold;
        padding: 10px 0 2px;
    }
</style>